import { gql } from 'apollo-angular';

export const Query_GetEquipmentCountingJournalSlicerValues = gql`
  query getEquipmentCountingJournalSlicerValues(
    $filter: DtoEquipmentCountingJournalMetricsFilter
  ) {
    getEquipmentCountingJournalSlicerValues(filter: $filter) {
      statuses {
        value
        count
      }
      locations {
        value
        count
      }
      journalIds {
        value
        label
        count
      }
      journalTypes {
        value
        count
      }
      fleetTypes {
        value
        count
      }
      equipmentCategories {
        value
        count
      }
      createdPeriods {
        value
        label
      }
    }
  }
`;
